import * as core from '../../../../../../../core'
import * as attainSpecKit from '../attain-spec-kit'

export const RESOURCE = {
  payload: {
    alias: 'deployment',
    appAlias: attainSpecKit.RESOURCE.payload.alias,
    description: 'Deployment tracking. Not yet implemented.',
    display: {
      isMain: true,
      position: 5,
    },
    name: 'Deployment',
    page: { alias: 'deployment' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
